/* filter-btn.js */
import LINKED_CONNECTIONS_TYPES from '../../data/linked-connection-types.json';

export default class FilterBtn {
    constructor() {
        this.BLOCK = null;
        this.BTN = null;
        this.CONTENT = null;
        this.SHOW_MORE = null;
        this.BLOCK_STATE = {
            hiddenContent: null,
            viewMore: false,
        };
        this.AJAX_PARAM = null;
    }

    /**
     * Inits instance
     * @param node - DOM node
     */
    init(node) {
        this.BLOCK = node;
        if (!this.BLOCK) throw new Error('node is not passed to init method of instance');

        this.BTN = this.BLOCK.querySelector('.filter-list__btn');
        this.CONTENT = this.BLOCK.querySelector('.filter-list__item-content');
        this.SHOW_MORE = this.BLOCK.querySelector('.filter-list__show-more');

        if (!this.BTN) throw new Error('.filter-list__btn is not found in DOM');
        if (!this.CONTENT) throw new Error('.filter-list__item-content is not found in DOM');

        if (this.checkOpenClass(this.BTN, 'open')) {
            this.BLOCK_STATE.hiddenContent = true;
        }

        this.BLOCK_STATE.viewMore =
            !!this.CONTENT && this.CONTENT.classList.contains('show-more-items');

        // if use bind, as below:
        // window.initFoo = this.toggleOpenClass.bind(this);
        // window.initFoo1 = this.toggleOpenClass.bind(this);
        // then window.initFoo === window.initFoo1 --- FALSE
        this.BTN.addEventListener('click', this.handleBtnClick);
        this.CONTENT.addEventListener('click', this.handleContentClick);

        if (this.SHOW_MORE) {
            if (this.BLOCK_STATE.viewMore) {
                this.setShowLessText();
            } else {
                this.setShowMoreText();
            }
            this.SHOW_MORE.addEventListener('click', this.toggleInvisibleItems);
        }
    }

    destroy() {
        // this.BTN.removeEventListener('click', this.handleBtnClick);
        // this.CONTENT.removeEventListener('click', this.handleContentClick);
        // this.SHOW_MORE.removeEventListener('click', this.toggleInvisibleItems);

        this.BLOCK = null;
        this.BTN = null;
        this.CONTENT = null;
        this.SHOW_MORE = null;
        this.BLOCK_STATE = {
            hiddenContent: null,
            viewMore: false,
        };
    }

    /* it would be great to store eventListeners in array to have possibility removeEventListener */
    removeAllListeners() {}

    /**
     * Handles btn click
     */
    handleBtnClick = () => this.toggleOpenClass();

    /**
     * Handles content click
     * @param e {Object} - event object
     */
    handleContentClick = e => {
        let { target } = e;
        if (
            !target.classList.contains('batteries-model-block-help-text-js') &&
            !target.classList.contains('range-slider__input') &&
            target.closest('.filter-list__item-content') &&
            !target.closest('.form-choice') &&
            target !== this.SHOW_MORE
        ) {
            if (!target.classList.contains('filter-list__sublist-item-cross')) {
                while (!target.classList.contains('filter-list__sublist-item')) {
                    target = target.parentNode;
                    if (target === document.body) {
                        target = null;
                        break;
                    }
                }

                if (target && target.dataset && target.dataset.ajaxParam) {
                    this.AJAX_PARAM = target.dataset.ajaxParam;
                    this.createAndDispatchEvent();
                }
            }

            // wrap this code with special logic to prevent adding eventListeners outside chosen container
            if (e.target.classList.contains('filter-list__sublist-item-cross')) {
                // eslint-disable-next-line prefer-destructuring
                target = e.target;
                this.AJAX_PARAM = target.dataset.ajaxParam;
                this.createAndDispatchEvent();
            }
        } else if (
            target.closest('.filter-list__item-content') &&
            target.closest('.form-choice') &&
            target !== this.SHOW_MORE
        ) {
            if (target.classList.contains('form-choice__input')) {
                this.handlerHybridOutlets(target);
                this.createAndDispatchEvent();
            }
        }
    };

    /**
     * Handles hybrid outles,
     * combine two ajax params in
     * one request
     */

    handlerHybridOutlets = target => {
        const targetAjaxParam = target.getAttribute('data-ajax-param');
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(LINKED_CONNECTIONS_TYPES)) {
            if (target.parentNode.getAttribute('data-item-name') === key && target.checked) {
                const linkedInput = document.querySelector(
                    `div[data-item-name='${value}'] > input`,
                );
                const linkedAjaxParam = linkedInput
                    ? linkedInput.getAttribute('data-ajax-param')
                    : '';
                if (linkedAjaxParam && !linkedAjaxParam.includes('?') && !linkedInput.checked) {
                    linkedInput.checked = true;
                    const index = linkedAjaxParam.split('Z').length - 1;
                    const ajaxParamLastPart = linkedAjaxParam.split('Z')[index];
                    this.AJAX_PARAM = `${targetAjaxParam}Z${ajaxParamLastPart}`;
                    return;
                }
                if (linkedAjaxParam && linkedAjaxParam.includes('?') && !linkedInput.checked) {
                    linkedInput.checked = true;
                    const index = linkedAjaxParam.lastIndexOf('Z');
                    const ajaxParamLastPart = linkedAjaxParam.slice(index);
                    const [ajaxParamFirstPart] = targetAjaxParam.split('?');
                    this.AJAX_PARAM = ajaxParamFirstPart + ajaxParamLastPart;
                    return;
                }
            }
        }
        this.AJAX_PARAM = targetAjaxParam;
    };

    /**
     *
     */
    toggleInvisibleItems = () => {
        this.BLOCK_STATE.viewMore = !this.BLOCK_STATE.viewMore;

        if (this.BLOCK_STATE.viewMore) {
            this.viewInvisibleItems();
        } else {
            this.hideInvisibleItems();
        }
    };

    /**
     *
     */
    toggleOpenClass() {
        if (!this.checkOpenClass(this.BTN, 'open')) {
            this.setOpenClass();
        } else {
            this.delOpenClass();
        }
        document.dispatchEvent(new CustomEvent('filter-button-click', { bubbles: true }));
    }

    /**
     *
     */
    setOpenClass() {
        this.BTN.classList.add('open');
        this.BLOCK.classList.add('open');
        this.CONTENT.classList.add('open');

        this.BLOCK_STATE.hiddenContent = true;
        this.BLOCK_STATE.viewMore = false;
    }

    /**
     *
     */
    delOpenClass() {
        this.BTN.classList.remove('open');
        this.BLOCK.classList.remove('open');
        this.CONTENT.classList.remove('open');

        this.BLOCK_STATE.hiddenContent = false;
        this.BLOCK_STATE.viewMore = false;
    }

    setShowLessText = () => {
        this.SHOW_MORE.textContent = this.SHOW_MORE.dataset.showLess || 'Show Less';
    };

    setShowMoreText = () => {
        this.SHOW_MORE.textContent = this.SHOW_MORE.dataset.showMore || 'Show More';
    };

    /**
     *
     */
    viewInvisibleItems() {
        this.setShowLessText();
        this.CONTENT.classList.add('show-more-items');
    }

    /**
     *
     */
    hideInvisibleItems() {
        this.setShowMoreText();
        this.CONTENT.classList.remove('show-more-items');
    }

    /**
     * Creates and dispatches custom event
     */
    createAndDispatchEvent() {
        let event = new CustomEvent('ajax-src-container-click', {
            bubbles: true,
            detail: { ajaxParam: this.AJAX_PARAM },
        });

        this.BLOCK.dispatchEvent(event);
        this.AJAX_PARAM = null;
    }

    /**
     *
     * @param node
     * @param cssClass
     * @returns {boolean}
     */
    checkOpenClass(node, cssClass) {
        return node.classList.contains(cssClass);
    }
}

/* \filter-btn.js */
